import axios from 'axios';
import { RouteHistory } from '../providers/route-provider';
//import { initializePush } from '../providers/notifications-provider';
import { getAdminRoles } from "../components/common/libs/helpers";

const filterUIRoles = function (user) {
    if (!user.roles || user.roles.length === 0) {
        if (user.role)
            user.roles = [user.role];
        else
            user.roles = ['donor'];
    }
    return user.roles.filter(i => [
        'admin', 'super-admin', 'mentorship-manager',
        'blog-manager', 'communications-manager', 'campaigns-manager',
        'accounting-manager', 'blog-editor', 'blog-translator',
        'funds-manager', 'donor', 'guest',
        'student', 'institution-manager',
    ].indexOf(i) !== -1)
}

const pickPrimaryRole = function (user) {
    const roles = filterUIRoles(user);
    if (!roles || roles.length === 0)
        return user.role || 'donor';
    const adminRoles = getAdminRoles();
    const adminRole = roles.find((role) => adminRoles.indexOf(role) !== -1);
    if (adminRole)
        return adminRole;
    if (roles.indexOf(user.role) !== -1)
        return user.role;
    return roles[0];
}
//Auth Store  state and functions
export default {
    state: function () {
        let loggedIn = false, user = {
            name: '',
            first_name: '',
            email: '',
            image: '',
            image_url: '',
            role: 'student',
            roles: [],
            token: '',
            token_type: '',

        };
        if (localStorage.hasOwnProperty('user')) {
            loggedIn = true;
            user = JSON.parse(localStorage.getItem('user'));
            user.roles = filterUIRoles(user);
            user.role = pickPrimaryRole(user);
            //Ignore GA for admins
            if (window.gtag && getAdminRoles().indexOf(user.role) !== -1) {
                window.gtag('config', 'GA_MEASUREMENT_ID', {
                    send_page_view: false
                });
            }
        }

        return {
            loggedIn: loggedIn,
            user: user,
        }
    },
    functions: {
        // These methods will also be avaiable anywhere we inject our
        // container context
        async login(user) {
            localStorage.setItem('user', JSON.stringify(user));
            let state = this.state;
            state.auth.loggedIn = true;
            state.auth.user = user;
            state.auth.user.role = pickPrimaryRole(user);
            this.setState(state);
            //Setup AXIOS
            axios.defaults.headers.common['Authorization'] = "Bearer " + user.token;
            //SetUp FCM
            //initializePush();
            //SetUp Notifications
            user.notifications.forEach(item => {
                this.notifications.add({
                    title: item.data.title,
                    body: item.data.body,
                    url: item.data.url,
                    type: item.data.type,
                    data: item.data,
                }, item.read_at !== null, true);
            });
            //Ignore GA for admins
            if (window.gtag && getAdminRoles().indexOf(state.auth.user.role) !== -1) {
                window.gtag('config', 'GA_MEASUREMENT_ID', {
                    send_page_view: false
                });
            }
        },
        async activateUser() {
            let state = this.state;
            state.auth.user.active = true;
            localStorage.setItem('user', JSON.stringify(state.auth.user));
            this.setState(state);
        },
        async updateUserEmail(email) {
            let state = this.state;
            state.auth.user.email = email;
            localStorage.setItem('user', JSON.stringify(state.auth.user));
            this.setState(state);
        },
        async updateUserData(user) {
            let state = this.state;
            user.roles = filterUIRoles(user);
            user.token = state.auth.user.token;
            user.token_type = state.auth.user.token_type;
            user.expires_at = state.auth.user.expires_at;
            user.role = state.auth.user.role;
            if (user.roles.indexOf(state.auth.user.role) === -1)
                user.role = pickPrimaryRole(user);
            state.auth.user = user;
            localStorage.setItem('user', JSON.stringify(state.auth.user));
            this.setState(state);
            //SetUp Notifications
            user.notifications.forEach(item => {
                this.notifications.add({
                    title: item.data.title,
                    body: item.data.body,
                    url: item.data.url,
                    type: item.data.type,
                    data: item.data,
                }, item.read_at !== null, true);
            });
        },
        async setRole(role) {
            let state = this.state;
            state.auth.user.role = role;
            localStorage.setItem('user', JSON.stringify(state.auth.user));
            this.setState(state);
        },
        async logout() {
            delete axios.defaults.headers.common['Authorization'];
            localStorage.removeItem('user');
            let state = this.state;
            state.auth = {
                loggedIn: localStorage.hasOwnProperty('user'),
                user: localStorage.hasOwnProperty('user') ? JSON.parse(localStorage.getItem('user')) : {
                    name: '',
                    first_name: '',
                    email: '',
                    image: '',
                    image_url: '',
                    role: 'student',
                    roles: [],
                    token: '',
                    token_type: '',
                    student: {
                        degree: {},
                        majro: {},
                    },
                    skills: [],
                    institutions: [],
                    active: false,
                }
            };
            this.setState(state);
            if (RouteHistory.location.pathname !== '/login') {
                RouteHistory.push('login');
            }
        }
    }
}
